import { Sidebar } from './sidebar';
import { AdminSidebar } from './admin-sidebar';
import { Header } from './header';
import { useAuthStore } from '@/stores/auth-store';

interface AppShellProps {
  children: React.ReactNode;
}

export function AppShell({ children }: AppShellProps) {
  const { user } = useAuthStore();
  const isAdmin = user?.role === 'super_admin';

  return (
    <div className="flex h-screen overflow-hidden">
      {isAdmin ? <AdminSidebar /> : <Sidebar />}
      <div className="flex flex-1 flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-y-auto bg-gray-50 p-4 lg:p-6">{children}</main>
      </div>
    </div>
  );
}
